export const fileIconClassMap = {
  xls: 'fas fa-file-excel',
  xlsx: 'fas fa-file-excel',
  pdf: 'fas fa-file-pdf',
  csv: 'fas fa-file-csv',
  doc: 'fas fa-file-word',
  docx: 'fas fa-file-word',
  docm: 'fas fa-file-word',
  ppt: 'fas fa-file-powerpoint',
  pptx: 'fas fa-file-powerpoint',
  pptm: 'fas fa-file-powerpoint',
  zip: 'fas fa-file-archive',
};

export const imageExts = ['jpg', 'jpeg', 'png', 'svg', 'gif', 'tif', 'tiff', 'eps', 'raw', 'cr2', 'nef', 'orf', 'sr2'];

export const videoExts = [
  'webm',
  'mkv',
  'flv',
  'vob',
  'ogv',
  'ogg',
  'rrc',
  'gifv',
  'mng',
  'mov',
  'avi',
  'qt',
  'wmv',
  'yuv',
  'rm',
  'asf',
  'amv',
  'mp4',
  'm4p',
  'm4v',
  'mpg',
  'mp2',
  'mpeg',
  'mpe',
  'mpv',
  'm4v',
  'svi',
  '3gp',
  '3g2',
  'mxf',
  'roq',
  'nsv',
  'flv',
  'f4v',
  'f4p',
  'f4a',
  'f4b',
];

export function isImage(type: string) {
  return type.startsWith('image/');
}

export function isMedia(type: string) {
  return type.startsWith('image/') || type.startsWith('video/');
}

export function isPDF(type: string) {
  return type === 'application/pdf';
}
